import React, { useState, useEffect, useRef } from "react";
import "./SolutionsSection.css";
import { Link } from "react-router-dom";

  const organizationSchema = {
    "@context": "https://schema.org",
    "@type": "MedicalOrganization",
    name: "Krisara Gastro and Liver Clinic",
    url: "https://krisaragastro.com/",
    logo: "https://i.ibb.co/HDcnBZt3/Rectangle-76.png",
    image: "https://i.ibb.co/HDcnBZt3/Rectangle-76.png",
    telephone: "+91 7569541532",
    email: "gastro@krisara.com",
    address: {
      "@type": "PostalAddress",
      streetAddress:
        "3rd Floor, Fairmount Square, Pet Basheerabad, Quthbullapur, Kompally",
      addressLocality: "Hyderabad",
      addressRegion: "Telangana",
      postalCode: "500014",
      addressCountry: "IN",
    },
    sameAs: [
      "https://www.facebook.com/krisaragastro",
      "https://www.instagram.com/krisaragastro",
    ],
  };

const solutionsData = [
  {
    title: "UPPER GI ENDOSCOPY",
    description:
      "Minimally invasive camera exam of the esophagus, stomach, and duodenum for ulcer, reflux, and celiac diagnosis.",
    image: "https://i.ibb.co/MyyMkcMp/image-93.png",
  },
  {
    title: "COLONOSCOPY",
    description:
      "A procedure to inspect the colon and rectum using a flexible camera to detect abnormalities.",
    image: "https://i.ibb.co/C3d16SSM/image-92.png",
  },
  {
    title: "LIVER FIBROSCAN",
    description:
      "A quick, non-invasive scan to assess liver fibrosis and detect liver damage early.",
    image: "https://i.ibb.co/HR803Bb/image-91.png",
  },
  {
    title: "ENDOSCOPIC RETROGADE CHOLANGIOPANCREATOGRAPHY(ERCP)",
    description:
      "ERCP is an advanced endoscopic procedure to diagnose and treat bile and pancreatic ducts.",
    image: "https://i.ibb.co/dwb9JSYW/image-90.png",
  },
  {
    title: "IBS & FUNCTIONAL GI MANAGEMENT",
    description:
      "Comprehensive treatment plans for irritable bowel syndrome and other functional GI disorders.",
    image: "https://i.ibb.co/p6ZXNNWX/image-89.png",
  },
  {
    title: "GERD & ACID REFLUX THERAPY",
    description:
      "Advanced diagnostics and therapy to treat gastroesophageal reflux disease (GERD).",
    image: "https://i.ibb.co/RGGCcCdg/image-88.png",
  },
];
const SolutionsSection = () => {
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setIsVisible(true);
          }
        });
      },
      { threshold: 0.2 } // 20% of section visible triggers animation
    );
    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }
    return () => {
      if (sectionRef.current) observer.unobserve(sectionRef.current);
    };
  }, []);
  return (
    <div
      ref={sectionRef}
      className={`solutions-container ${isVisible ? "fade-in" : ""}`}
    >
      <div className="solutions-box">
        <div className={`solutions-left ${isVisible ? "animate" : ""}`}>
          <h3 className="solutions-heading">OUR SOLUTIONS</h3>
          <p className="solutions-subtext">
            Start your journey with a customized treatment plan from a certified
            gastroenterologist.
          </p>
          <ul className="solutions-list">
            {solutionsData.map((item, index) => (
              <li
                key={index}
                className={`solution-item ${isVisible ? "animate-list" : ""} ${
                  selectedIndex === index ? "active" : ""
                }`}
                style={{ animationDelay: `${index * 0.15}s` }}
                onClick={() => setSelectedIndex(index)}
              >
                <span className="solution-bullet"></span>
                {item.title}
                <span className="solution-arrow">→</span>
              </li>
            ))}
          </ul>
        </div>
        <div className={`solutions-right ${isVisible ? "fade-scale" : ""}`}>
          <div className="solutions-image-wrapper">
            <img
              src={solutionsData[selectedIndex].image}
              alt={solutionsData[selectedIndex].title}
              className="solutions-image"
            />
          </div>
          <p className="solutions-description">
            {solutionsData[selectedIndex].description}
          </p>
         <Link to="/Appointment" style={{textDecoration:"none"}}>
  <button className="solutions-appointment-btn">
    <span className="solutions-btn-bullet"></span> Book an Appointment
  </button>
</Link>
        </div>
      </div>
    </div>
  );
};
export default SolutionsSection;